import React from 'react';

/**
 * Labelled Bootstrap text input.
 *
 * The existing wizard apps repeat this markup inline in every step; the
 * Personal Data Sheet has far too many fields for that to stay readable.
 *
 * `formatter` rewrites the value on the way out (see format.js) so phone
 * numbers can be masked as the client types. `min`/`max` are here for the
 * date fields - a native date input otherwise happily accepts a five-digit
 * year.
 */
export default function TextInput({
  id,
  label,
  value,
  onChange,
  type = 'text',
  step,
  min,
  max,
  required = false,
  placeholder,
  help,
  error,
  col = 'col-md-6',
  maxLength,
  autoComplete,
  disabled = false,
  formatter,
}) {
  return (
    <div className={col}>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      <input
        id={id}
        type={type}
        step={step}
        min={min}
        max={max}
        maxLength={maxLength}
        autoComplete={autoComplete}
        disabled={disabled}
        className={`form-control${error ? ' is-invalid' : ''}`}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={(e) => onChange(
          formatter ? formatter(e.target.value) : e.target.value,
        )}
      />
      {help && <div className="form-text">{help}</div>}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
